import { render, staticRenderFns } from "./CmsLink.vue?vue&type=template&id=4159c964&scoped=true&"
import script from "./CmsLink.vue?vue&type=script&lang=ts&"
export * from "./CmsLink.vue?vue&type=script&lang=ts&"
import style0 from "./CmsLink.vue?vue&type=style&index=0&id=4159c964&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4159c964",
  null
  
)

export default component.exports